import { createI18n } from 'vue-i18n';
import fr from './locales/fr';
import en from './locales/en';
import it from './locales/it';
import de from './locales/de';
function detectBrowserLanguage() {
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0].toLowerCase();
    const supportedLanguages = ['fr', 'en', 'it', 'de'];
    if (supportedLanguages.includes(langCode)) {
        return langCode;
    }
    const savedLang = localStorage.getItem('app-language');
    if (savedLang && supportedLanguages.includes(savedLang)) {
        return savedLang;
    }
    return 'fr';
}
const savedLanguage = localStorage.getItem('app-language');
const detectedLanguage = savedLanguage || detectBrowserLanguage();
const i18n = createI18n({
    legacy: false,
    locale: detectedLanguage,
    fallbackLocale: 'fr',
    messages: {
        fr,
        en,
        it,
        de,
    },
});
if (!savedLanguage) {
    localStorage.setItem('app-language', detectedLanguage);
}
export default i18n;
